import { XIcon } from 'lucide-react';
import type { ChangeEvent, FC } from 'react';

import { Button, Sheet, SheetContent, Text } from '@/design-system/components/ui';

interface SideBarProps {
  title: string;
  container?: HTMLDivElement | null;
  sidebarContent?: React.ReactNode;
  open?: boolean;
  onClose?: () => void;
  onGroupChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const SideBar: FC<SideBarProps> = (props) => {
  const { title, onClose, open, sidebarContent } = props;

  return (
    <Sheet modal={false} open={!!open} onOpenChange={(isOpen) => !isOpen && onClose?.()}>
      <SheetContent
        inline
        side="left"
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        style={{ ['--sheet-inline-size' as 'width']: '300px' }}
        className="tw:h-full tw:border-r tw:border-border tw:p-0"
      >
        <div className="tw:flex tw:flex-col tw:gap-4 tw:p-6">
          <div className="tw:flex tw:items-center tw:justify-between tw:flex-row">
            <Text variant="title-xs">{title}</Text>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <XIcon size={20} />
            </Button>
          </div>
          {sidebarContent}
        </div>
      </SheetContent>
    </Sheet>
  );
};
